import { ResourcesFields } from '../pages/ResourcesAdmin/Fields/ResourcesFields'
import { AddFieldsCategory } from '../pages/ResourcesAdmin/Categories/AddFieldsCategory'
import { ResourcesModels } from '../pages/ResourcesAdmin/Models/ResourcesModels'
import { AddModel } from '../pages/ResourcesAdmin/Models/AddModel'
import { Companies } from '../pages/Companies/Companies'
import { ResourcesCategories } from '../pages/ResourcesAdmin/Categories/ResourcesCategories'
import { SingleResourcesCategory } from '../pages/ResourcesAdmin/Categories/SingleResourcesCategory'
import { AddCompany } from '../pages/Companies/AddCompany'
import { EditModel } from '../pages/ResourcesAdmin/Models/EditModel'
import { SingleCompany } from '../pages/Companies/SingleCompany'
import { EditCompany } from '../pages/Companies/EditCompany'
import { SingleField } from 'pages/ResourcesAdmin/Fields/SingleField'
import { Industries } from 'pages/Industries/Industries'
import { AddIndustry } from 'pages/Industries/AddIndustry'
import { EditIndustry } from 'pages/Industries/EditIndustry'
import { InventoryFields } from 'pages/Inventory/Settings/InventoryFields'
import { InventoryCategories } from 'pages/Inventory/Settings/InventoryCategories'
import { SingleInvField } from 'pages/Inventory/Settings/SingleInvField'
import { InventoryCategory } from 'pages/Inventory/Settings/InventoryCategory'
import { InventorySubcategoryFields } from 'pages/Inventory/Settings/InventorySubcategoryFields'
import { EditRoleTemplate } from 'pages/RoleTemplates/EditRoleTemplate'
import { AddRoleTemplate } from 'pages/RoleTemplates/AddRoleTemplate'
import { SingleRoleTemplate } from 'pages/RoleTemplates/SingleRoleTemplate'
import { RoleTemplates } from 'pages/RoleTemplates/RoleTemplates'
import { CompanyAdmins } from 'pages/CompanyAdmins/CompanyAdmins'
import { SingleInventorySubcategory } from 'pages/Inventory/Settings/SingleInventorySubcategory'
import { RolePermissionPolicyTemplates } from 'pages/RoleTemplates/RolePermissionPoliciesTemplates/RolePermissionPolicyTemplates'
import { EditRolePermissionPolicyTemplate } from 'pages/RoleTemplates/RolePermissionPoliciesTemplates/EditRolePermissionPolicyTemplate'
import { AddRolePermissionPolicyTemplate } from 'pages/RoleTemplates/RolePermissionPoliciesTemplates/AddRolePermissionPolicyTemplate'

export const adminRoutes = [
  {
    path: 'resources-role-templates',
    Component: RoleTemplates,
  },
  {
    path: 'resources-role-templates/:id',
    Component: SingleRoleTemplate,
  },
  {
    path: 'resources-role-templates/add',
    Component: AddRoleTemplate,
  },
  {
    path: 'resources-role-templates/:id/edit',
    Component: EditRoleTemplate,
  },
  {
    path: 'resources-role-templates/permission-policies',
    Component: RolePermissionPolicyTemplates,
  },
  {
    path: 'resources-role-templates/permission-policies/add',
    Component: AddRolePermissionPolicyTemplate,
  },
  {
    path: 'resources-role-templates/permission-policies/single-permission/:id',
    Component: EditRolePermissionPolicyTemplate,
  },
  {
    path: 'resources-fields',
    Component: ResourcesFields,
  },
  {
    path: 'resources-fields/:id',
    Component: SingleField,
  },

  {
    path: 'resources-fields/add',
    Component: AddFieldsCategory,
  },
  {
    path: 'resources-models',
    Component: ResourcesModels,
  },
  {
    path: 'resources-models/add',
    Component: AddModel,
  },
  {
    path: 'resources-models/:id',
    Component: EditModel,
  },
  {
    path: 'companies',
    Component: Companies,
  },
  {
    path: 'companies/:id',
    Component: SingleCompany,
  },
  {
    path: 'companies/add',
    Component: AddCompany,
  },
  {
    path: 'companies/edit/:id',
    Component: EditCompany,
  },
  {
    path: 'industries',
    Component: Industries,
  },
  {
    path: 'industries/add',
    Component: AddIndustry,
  },
  {
    path: 'industries/:id/edit',
    Component: EditIndustry,
  },

  {
    path: 'company-admins',
    Component: CompanyAdmins,
  },
  {
    path: 'inventory-fields',
    Component: InventoryFields,
  },
  {
    path: 'inventory-fields/:id',
    Component: SingleInvField,
  },
  {
    path: 'inventory-categories',
    Component: InventoryCategories,
  },
  {
    path: 'inventory-categories/:id',
    Component: InventoryCategory,
  },
  {
    path: 'inventory-categories/:id/subcategory/:subId',
    Component: SingleInventorySubcategory,
  },
  {
    path: 'inventory-categories/:id/subcategory/:subId/fields',
    Component: InventorySubcategoryFields,
  },

  {
    path: 'resources-categories',
    Component: ResourcesCategories,
  },
  {
    path: 'resources-categories/:id',
    Component: SingleResourcesCategory,
  },
  {
    path: 'resources-categories/:id/add',
    Component: AddFieldsCategory,
  },
]
